import styled from "styled-components";

export const InsuredDataContainer = styled.div`
  .personal-data-buttons {
    display: flex;
    &__item {
      margin-right: 70px;
      min-width: 100px;
      &:last-child {
        margin-right: 20px;
        width: 180px;
      }
    }
  }

  .noEvents {
    pointer-events: none;
  }

  .data-flow-status {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  .flex-row {
    display: flex;
    align-items: center;
    clear: both;

    label {
      width: initial;
      margin-right: 40px;
    }
  }

  .personal-data-wrapper {
    padding: 20px;
    background-color: #fbfbfb;
    display: block;
    width: 100%;
    margin-top: 20px;
  }
`;
